import { Fragment } from "react";
import { USP_LIST } from "@/pages/quiz/base/components/header/common";
import { clsxm } from "@/utils/clsxm";

interface IProps {
  t10_2?: boolean;
}

const ABTest10USPDesktop = ({ t10_2 }: IProps) => (
  <div className="w-full bg-dark-purple-2 px-6 hidden md:flex md:justify-center">
    <div className="flex flex-1 justify-center gap-x-4 relative max-w-[1200px] mx-auto">
      {USP_LIST.map((item, index) => (
        <Fragment key={index}>
          <div key={index} className="flex-1">
            <div className="flex items-center justify-center gap-3 min-h-14">
              <div className="flex-shrink-0">{item.icon}</div>
              <p
                className={clsxm(
                  "text-white whitespace-pre-wrap font-semibold text-xs leading-[15px]",
                  t10_2 && "whitespace-normal"
                )}
              >
                {item.title}
              </p>
            </div>
          </div>

          {!t10_2 && index !== USP_LIST.length - 1 && (
            <div className="w-px bg-main-button-v2" />
          )}
        </Fragment>
      ))}
    </div>
  </div>
);

export { ABTest10USPDesktop };
